import { Fragment, ReactNode } from "react";
import img from "../../images/film.jpg";

type Props = {
  children?: ReactNode;
};

const stats = [
  { value: "31", label: "Communes" },
  { value: "3", label: "Pôles de services" },
  { value: "12", label: "Membres du bureau" },
];

const navLinks = [
  { href: "#mot-du-president", label: "Mot du président" },
  { href: "#bureau", label: "Le bureau" },
  { href: "#assesseurs", label: "Assesseurs" },
  { href: "#equipe", label: "Notre équipe" },
];

const HeroSection = (props: Props) => {
  return (
    <Fragment>
      <div className="container mx-auto mt-20 sm:px-40 md:p-12">
        <span className="block text-sm font-semibold tracking-wide text-center text-primary uppercase">
          Hydreaulys
        </span>
        <div className="mt-2 text-3xl font-bold text-center text-black">
          Qui sommes-nous ?
        </div>

        <div className="mt-8 md:mt-16">
          <div className="flex flex-col justify-center gap-10 lg:flex-row lg:items-center">
            <div className="lg:mr-4 lg:flex-1">
              <p className="text-lg leading-relaxed text-justify text-[#3a3a3a]">
                <span className="font-black text-primary">Hydreaulys </span>
                est un établissement territorial en charge de la collecte, du
                transport et de l’assainissement des eaux usées et pluviales
                de l’ouest parisien. Il gère également l’aménagement, la
                restauration, l’entretien et la mise en valeur du ru de Gally.
                Son territoire s’étend sur 31 communes.
                <br />
                <br />
                Le Syndicat est administré par un Comité composé de délégués
                élus par les Conseils Municipaux des communes et des Conseils
                Communautaires des communautés associées. Le nombre de
                délégués est déterminé en fonction du nombre d’habitants.
              </p>

              <div className="grid grid-cols-3 gap-3 mt-6">
                {stats.map((stat) => (
                  <div key={stat.label} className="p-3 text-center rounded-lg bg-primary/5">
                    <p className="text-xl font-bold text-primary">{stat.value}</p>
                    <p className="text-xs text-gray-600">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex justify-center lg:flex-1">
              <img src={img} alt="" className="rounded-lg" />
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-2 py-3 mt-10 border-t border-b border-gray-200">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-4 py-2 text-sm font-semibold rounded-full text-primary bg-primary/10 hover:bg-primary/20"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </Fragment>
  );
};

export default HeroSection;
